var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('h1',[_vm._v("Privacy")]),_c('p',[_vm._v("We do not store any personal information, only your google id to prevent massive amounts of bots.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }